export default __webpack_public_path__ + "static/media/calendar.2f2afe7f.svg";